"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationClient = void 0;
const client_1 = require("@leid/client");
const cache_1 = require("./utils/cache");
class LocationClient extends client_1.CachedClientBase {
    async getLocations(filter, sortingData, distanceCoordinates) {
        let response;
        try {
            const key = (0, cache_1.getCacheLocationsKey)(filter, sortingData, distanceCoordinates);
            const getCache = await this.getRedisClient()?.get(key);
            if (getCache) {
                return { success: true, data: JSON.parse(getCache) };
            }
            const params = { ...filter, ...sortingData, ...distanceCoordinates };
            response = await this.httpClient.get('/location', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLocations error on a call', filter);
        }
    }
    async getLocation(id) {
        let response;
        try {
            const key = (0, cache_1.getCacheLocationKey)(id);
            const getCache = await this.getRedisClient()?.get(key);
            if (!getCache) {
                response = await this.httpClient.get(`/location/${id}`);
                return response.data;
            }
            const data = JSON.parse(getCache);
            response = { success: true, data: data || null };
            return response;
        }
        catch (err) {
            return this.processError(err, 'getLocation error on a call', id);
        }
    }
    async createLocation(location) {
        try {
            const response = await this.httpClient.post('/location', location);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createLocation error on a call', location);
        }
    }
    async findClosestLocations(filter) {
        try {
            const response = await this.httpClient.get('/location/closest/locations', { params: filter });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'findClosestLocation error on a call', filter);
        }
    }
    async getLocationsWithDistanceFromLatLong(filter) {
        try {
            const response = await this.httpClient.get('/location/coordinates/closest', { params: filter });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLocationsWithDistanceFromLatLong error on a call', filter);
        }
    }
    async updateLocation(id, location) {
        try {
            const response = await this.httpClient.put(`/location/${id}`, location);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateLocation error on a call', id, location);
        }
    }
    async getSublocations(filter) {
        try {
            const response = await this.httpClient.get('/sublocation', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSublocations error on a call', filter);
        }
    }
    async getSublocationWithDevices(request) {
        try {
            const response = await this.httpClient.get('/sublocation/devices', {
                params: request,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSublocationWithDevices error on a call', request);
        }
    }
    async getSublocation(id) {
        try {
            const response = await this.httpClient.get(`/sublocation/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSublocation error on a call', id);
        }
    }
    async createSublocation(sublocation) {
        try {
            const response = await this.httpClient.post('/sublocation', sublocation);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createSublocation error on a call', sublocation);
        }
    }
    async updateSublocation(id, sublocation) {
        try {
            const response = await this.httpClient.put(`/sublocation/${id}`, sublocation);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateSublocation error on a call', id, sublocation);
        }
    }
    async triggerSublocationOutput(id, request) {
        try {
            const response = await this.httpClient.post(`/sublocation/${id}/output`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerSublocationOutput error on a call', id, request);
        }
    }
    async getSublocationShadow(sublocationId, shadowName) {
        try {
            const response = await this.httpClient.get(`/sublocation/${sublocationId}/shadow/${shadowName}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSublocationShadow error on a call', sublocationId, shadowName);
        }
    }
    async sendDoorsPeekEvent(id) {
        try {
            const response = await this.httpClient.post(`/sublocation/${id}/doors/peek`, {});
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendDoorsPeekEvent error on a call', id);
        }
    }
    async sendHealthCheckEvent(id) {
        try {
            const response = await this.httpClient.post(`/sublocation/${id}/healthcheck`, {});
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendHealthCheckEvent error on a call', id);
        }
    }
    async sendCameraStartStreamingEvent(request) {
        try {
            const response = await this.httpClient.post(`/sublocation/${request.sublocationId}/camera/start-streaming`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendCameraStartStreamingEvent error on a call', request);
        }
    }
    async getGates(filter) {
        try {
            const response = await this.httpClient.get('/gate', { params: filter });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getGates error on a call', filter);
        }
    }
    async getGate(id) {
        try {
            const response = await this.httpClient.get(`/gate/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getGate error on a call', id);
        }
    }
    async createGate(gate) {
        try {
            const response = await this.httpClient.post('/gate', gate);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createGate error on a call', gate);
        }
    }
    async updateGate(id, gate) {
        try {
            const response = await this.httpClient.put(`/gate/${id}`, gate);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateGate error on a call', id, gate);
        }
    }
    async getEventLogs(filter) {
        try {
            const response = await this.httpClient.get('/eventlog', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getEventLogs error on a call', filter);
        }
    }
    async getEventLog(id) {
        try {
            const response = await this.httpClient.get(`/eventlog/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getEventLog error on a call', id);
        }
    }
    async createEventLog(event) {
        try {
            const response = await this.httpClient.post('/eventlog', event);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createEventLog error on a call', event);
        }
    }
    async createCameraRecording(cameraRecordingRequest) {
        try {
            const response = await this.httpClient.post('/camera-recording', cameraRecordingRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createEventLog error on a call', cameraRecordingRequest);
        }
    }
    async getCameraRecordings(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/camera-recording', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCameraRecordings error on a call', filter);
        }
    }
    async getCameraRecording(id) {
        try {
            const response = await this.httpClient.get(`/camera-recording/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCameraRecording error on a call', id);
        }
    }
    async updateCameraRecording(id, event) {
        try {
            const response = await this.httpClient.put(`/camera-recording/${id}`, event);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateCameraRecoridng error on a call', id, event);
        }
    }
    async getCameraRecordingAccessLogs(filter) {
        try {
            const response = await this.httpClient.get('/camera-recording-access-log', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCameraRecordingAccessLogs error on a call', filter);
        }
    }
    async getCameraRecordingAccessLog(id) {
        try {
            const response = await this.httpClient.get(`/camera-recording-access-log/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCameraRecordingAccessLog error on a call', id);
        }
    }
    async createCameraRecordingAccessLog(event) {
        try {
            const response = await this.httpClient.post('/camera-recording-access-log', event);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createCameraRecordingAccessLog error on a call', event);
        }
    }
    async updateCameraRecordingAccessLog(id, event) {
        try {
            const response = await this.httpClient.put(`/camera-recording-access-log/${id}`, event);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateCameraRecordingAccessLog error on a call', id, event);
        }
    }
    async getRegion(id) {
        let response;
        try {
            const key = (0, cache_1.getCacheRegionKey)(id);
            const getCache = await this.getRedisClient()?.get(key);
            if (!getCache) {
                response = await this.httpClient.get(`/region/${id}`);
                return response.data;
            }
            const data = JSON.parse(getCache);
            response = { success: true, data: data || null };
            return response;
        }
        catch (err) {
            return this.processError(err, 'getRegion error on a call', id);
        }
    }
    async getRegions(filter, sortingData, distanceCoordinates) {
        let response;
        try {
            const key = (0, cache_1.getCacheRegionsKey)(filter, sortingData, distanceCoordinates);
            const getCache = await this.getRedisClient()?.get(key);
            if (getCache) {
                return { success: true, data: JSON.parse(getCache) };
            }
            const params = { ...filter, ...sortingData, ...distanceCoordinates };
            response = await this.httpClient.get('/region', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRegions error on a call', filter);
        }
    }
    async createRegion(region) {
        try {
            const response = await this.httpClient.post('/region', region);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createRegion error on a call', region);
        }
    }
    async updateRegion(id, region) {
        try {
            const response = await this.httpClient.put(`/region/${id}`, region);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateRegion error on a call', id, region);
        }
    }
    async deleteRegion(id) {
        try {
            const response = await this.httpClient.delete(`/region/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteRegion error on a call', id);
        }
    }
    async deleteManager(id) {
        try {
            const response = await this.httpClient.delete(`/manager/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteManager error on a call', id);
        }
    }
    async getOpeningHours(filter) {
        try {
            const response = await this.httpClient.get('/opening-hours', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOpeningHours error on a call', filter);
        }
    }
    async getProductOpeningHours(productId) {
        try {
            const response = await this.httpClient.get(`/opening-hours/products/${productId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductOpeningHours error on a call', productId);
        }
    }
    async getSpecificOpeningHours(id) {
        try {
            const response = await this.httpClient.get(`/opening-hours/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSpecificOpeningHours error on a call', id);
        }
    }
    async createOpeningHour(openingHour) {
        try {
            const response = await this.httpClient.post('/opening-hours', openingHour);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOpeningHour error on a call', openingHour);
        }
    }
    async updateOpeningHour(id, openingHour) {
        try {
            const response = await this.httpClient.put(`/opening-hours/${id}`, openingHour);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOpeningHour error on a call', id, openingHour);
        }
    }
    async deleteOpeningHour(id) {
        try {
            const response = await this.httpClient.delete(`/opening-hours/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteOpeningHour error on a call', id);
        }
    }
    async getExceptionDays(filter) {
        try {
            const response = await this.httpClient.get('/exception-day', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getExceptionDays error on a call', filter);
        }
    }
    async getExceptionDay(id) {
        try {
            const response = await this.httpClient.get(`/exception-day/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getExceptionDay error on a call', id);
        }
    }
    async createExceptionDay(exceptionDay) {
        try {
            const response = await this.httpClient.post('/exception-day', exceptionDay);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createExceptionDay error on a call', exceptionDay);
        }
    }
    async updateExceptionDay(id, exceptionDay) {
        try {
            const response = await this.httpClient.put(`/exception-day/${id}`, exceptionDay);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateExceptionDay error on a call', id, exceptionDay);
        }
    }
    async deleteExceptionDay(id) {
        try {
            const response = await this.httpClient.delete(`/exception-day/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteExceptionDay error on a call', id);
        }
    }
    // Location sharing models
    async createLocationSharingModel(locationSharingModel) {
        try {
            const response = await this.httpClient.post('/location-sharing-models', locationSharingModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createLocationSharingModel error on a call', locationSharingModel);
        }
    }
    async getLocationSharingModels(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/location-sharing-models', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLocationSharingModels error on a call', filter, sortingData);
        }
    }
    async getLocationSharingModel(id) {
        try {
            const response = await this.httpClient.get(`/location-sharing-models/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLocationSharingModel error on a call', id);
        }
    }
    async getLocationSharingInfo(locationId, productId, activationDate) {
        try {
            const params = { productId, activationDate };
            const response = await this.httpClient.get(`/location/${locationId}/sharing-models`, {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLocationSharingInfo error on a call', locationId, productId);
        }
    }
    // ====== SETTINGS ======:
    async getSettings(filter) {
        try {
            const response = await this.httpClient.get('/settings', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSettings error on a call', filter);
        }
    }
    async getSetting(id) {
        try {
            const response = await this.httpClient.get(`/settings/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSetting error on a call', id);
        }
    }
    async createSetting(setting) {
        try {
            const response = await this.httpClient.post('/settings', setting);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createSetting error on a call', setting);
        }
    }
    async updateSetting(id, setting) {
        try {
            const response = await this.httpClient.put(`/settings/${id}`, setting);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateSetting error on a call', id, setting);
        }
    }
    async deleteSetting(id) {
        try {
            const response = await this.httpClient.delete(`/settings/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteSetting error on a call', id);
        }
    }
    async getSettingForUser(managerId, userId, settingType) {
        try {
            const response = await this.httpClient.get(`/settings/user/${userId}`, {
                params: { managerId, settingType },
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSettingForUser error on a call', managerId, userId);
        }
    }
}
exports.LocationClient = LocationClient;
